export default class UrlUtils {
  static updateSearchParameter(key, value, reloadPage = false) {
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);
    const paramExists = searchParams.has(key);

    if (paramExists) {
      const currentValue = searchParams.get(key);
      if (currentValue === value) {
        return;
      }
    }
    else if (!value) {
      return;
    }

    if (value) {
      searchParams.set(key, value);
    } else {
      searchParams.delete(key);
    }

    let newUrl = url.pathname;

    const searchParamsStr = searchParams.toString();
    if (searchParamsStr) {
      newUrl += `?${searchParamsStr}`;
    }

    window.history.pushState(null, '', newUrl);

    if (reloadPage) {
      window.location.reload();
    }
  }
}
